module.exports = __webpack_public_path__ + "img/image-profile.11f4fe67.png";